import { Injectable } from '@angular/core';
import { BehaviorSubject, from } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

import { sendObservabilityLog } from '@shared/analytics/ITXObservabilityCore/helper';

@Injectable()
export class HlsService {
    private readonly _hlsLibrary$: BehaviorSubject<any> = new BehaviorSubject(false);

    private isLoading: boolean = false;

    public hlsLibrary$ = this._hlsLibrary$.asObservable().pipe(
        first((isLoaded) => !isLoaded && !this.isLoading),
        switchMap((library) => {
            if (!library) {
                this.isLoading = true;
                return from(this._loadHlsLibrary());
            }
            return library;
        })
    );

    private async _loadHlsLibrary(): Promise<any> {
        try {
            const HLS = (await import('hls.js')).default;
            this._hlsLibrary$.next(HLS);
            return HLS;
        } catch (error) {
            sendObservabilityLog(error, 'HlsService _loadHlsLibrary');
            return undefined;
        }
    }
}
